import {$dom} from '../../helpers/dom';
import {$events} from '../../helpers/events';
import variables from '../../variables';
import gsap from 'gsap';
import {preventDefault} from '../../helpers/_utilities';

const {
	exist,
	hasClass,
	removeClass,
	addClass,
	get
} = $dom;

export default function mobileMenu(
	menuSelector = '.js-menu',
	buttonSelector = '.js-menu-button',
	duration = .3
) {

	if (exist([menuSelector, buttonSelector])) {

		const
			{active} = variables.classNames,
			initYTopShift = gsap.getProperty(menuSelector, 'y')
		;

		function close() {
			removeClass(menuSelector, active);
			removeClass(buttonSelector, active);
			gsap.to(menuSelector, {
				y: initYTopShift,
				ease: 'ease-in',
				duration,
				onComplete() {
					$events.delegate.off('click tap', document, closeByClickOutside)
				}
			})
		}

		function show() {
			addClass(menuSelector, active);
			addClass(buttonSelector, active);
			gsap.to(menuSelector, {
				y: 0,
				ease: 'ease-out',
				duration,
				onComplete() {
					$events.delegate.on('click tap', document, closeByClickOutside)
				}
			})
		}

		function toggleMenu(e) {
			preventDefault(e);
			if (hasClass(get(menuSelector), active)) {
				close()
			} else {
				show()
			}
		}

		function closeByClickOutside(event) {
			const menu = get(menuSelector);
			const isClickInside = menu.contains(event.target);

			if (!isClickInside) close();
		}

		const
			init = () => {
				$events.delegate.on('click tap', buttonSelector, toggleMenu)
			},
			destroy = () => {
				$events.delegate.off('click tap', buttonSelector, toggleMenu)
			}
		;

		return {init, destroy, close, show}
	}
}
